function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { PlaybackType } from '../../../core/player/playout-data';
export var AgfNielsenMetaAdapter = /*#__PURE__*/ function() {
    "use strict";
    function AgfNielsenMetaAdapter() {
        _class_call_check(this, AgfNielsenMetaAdapter);
    }
    _create_class(AgfNielsenMetaAdapter, null, [
        {
            key: "adaptLiveContentMetadata",
            value: function adaptLiveContentMetadata(metadata) {
                var assetid = metadata.assetid, channelName = metadata.channelName, formatId = metadata.formatId, isAvailableOverLinearTv = metadata.isAvailableOverLinearTv, manifestUrl = metadata.manifestUrl, programmeBrand = metadata.programmeBrand;
                // metadata info available in https://wiki.at.sky/pages/viewpage.action?spaceKey=CC&title=AGF+Nielsen
                return _object_spread_props(_object_spread({
                    type: 'content',
                    assetid: assetid,
                    program: "".concat(programmeBrand || 'UNKNOWN'),
                    title: '24_7 livestream',
                    // default for live
                    length: '86400',
                    // default for live, should be planned length for event-livestreams
                    nol_c0: 'p0,0',
                    // default for live
                    nol_c2: "p2,".concat(isAvailableOverLinearTv !== null && isAvailableOverLinearTv !== void 0 ? isAvailableOverLinearTv : 'N'),
                    nol_c5: "p5,".concat(manifestUrl),
                    nol_c7: "p7,".concat(assetid),
                    nol_c8: 'p8,',
                    // default value, reserved for AGF
                    nol_c9: 'p9,24_7 livestream',
                    // default for live
                    nol_c10: "p10,".concat(channelName),
                    nol_c12: 'p12,Content'
                }, // default for live
                formatId && {
                    nol_c15: "p15,".concat(formatId)
                }), {
                    nol_c16: "p16,".concat(formatId !== null && formatId !== void 0 ? formatId : assetid),
                    nol_c18: 'p18,Y'
                });
            }
        },
        {
            key: "adaptVodContentMetadata",
            value: // default for live
            function adaptVodContentMetadata(metadata, nrsMetadata) {
                var type = metadata.type, assetid = metadata.assetid, assetTitle = metadata.assetTitle, duration = metadata.duration, formatId = metadata.formatId, isAvailableOverLinearTv = metadata.isAvailableOverLinearTv, manifestUrl = metadata.manifestUrl, programmeBrand = metadata.programmeBrand, publisher = metadata.publisher;
                var nol_c2 = (nrsMetadata === null || nrsMetadata === void 0 ? void 0 : nrsMetadata.c2) || isAvailableOverLinearTv;
                var nol_c10 = (nrsMetadata === null || nrsMetadata === void 0 ? void 0 : nrsMetadata.c10) || (publisher !== null && publisher !== void 0 ? publisher : 'Sky');
                var nol_c15 = (nrsMetadata === null || nrsMetadata === void 0 ? void 0 : nrsMetadata.c15) || formatId;
                var nol_c16 = (nrsMetadata === null || nrsMetadata === void 0 ? void 0 : nrsMetadata.c16) || (formatId !== null && formatId !== void 0 ? formatId : assetid);
                var category_1 = nrsMetadata === null || nrsMetadata === void 0 ? void 0 : nrsMetadata.category_1;
                // metadata info available in https://wiki.at.sky/pages/viewpage.action?spaceKey=CC&title=AGF+Nielsen
                return _object_spread(_object_spread_props(_object_spread({
                    type: type.toLowerCase(),
                    assetid: assetid,
                    program: "".concat(programmeBrand || 'UNKNOWN'),
                    title: assetTitle,
                    length: Math.round(duration).toString(),
                    nol_c0: 'p0,0',
                    // hardcoded for go live
                    nol_c2: "p2,".concat(nol_c2 !== null && nol_c2 !== void 0 ? nol_c2 : 'N'),
                    nol_c5: "p5,".concat(manifestUrl),
                    nol_c7: "p7,".concat(assetid),
                    nol_c8: 'p8,',
                    // default value, reserved for AGF
                    nol_c9: "p9,".concat(assetTitle),
                    nol_c10: "p10,".concat(nol_c10),
                    nol_c12: "p12,".concat(type)
                }, // TODO: confirm if this can be Content | Trailer
                nol_c15 && {
                    nol_c15: "p15,".concat(nol_c15)
                }), {
                    nol_c16: "p16,".concat(nol_c16),
                    nol_c18: 'p18,N'
                }), // default for VOD
                category_1 && {
                    category_1: category_1
                });
            }
        },
        {
            key: "adaptAdContentMetadata",
            value: function adaptAdContentMetadata(metadata) {
                var type = metadata.adType.toLowerCase();
                return {
                    type: type,
                    assetid: metadata.assetId,
                    title: metadata.title,
                    length: Math.round(metadata.duration).toString(),
                    nol_c2: "p2,".concat(metadata.isWeb ? 'Y' : 'N'),
                    nol_c4: "p4,".concat(type),
                    nol_c8: 'p8,',
                    // default value, reserved for AGF
                    nol_c10: 'p10,Sky',
                    nol_c11: "p11,".concat(metadata.assetId),
                    nol_c12: 'p12,Ad',
                    nol_c17: "p17,".concat(type),
                    nol_c18: metadata.playbackType === PlaybackType.Live ? 'p18,Y' : 'p18,N'
                };
            }
        }
    ]);
    return AgfNielsenMetaAdapter;
}();

//# sourceMappingURL=agf-nielsen-meta-adapter.js.map